import { useUserEnvStore } from '@/common/stores/user-env';
import { useDashboardUserEnvStore } from '@/dashboard/stores/dashboard-user-env';

export const useFilterEnvStore = (useDashboard = false) => {
  const getEnvStore = useDashboard ? useDashboardUserEnvStore : useUserEnvStore;
  const envStore = getEnvStore();

  const getEnv = async <T>(key: string | undefined): Promise<T | null> => {
    if (!key) return null;
    return await envStore.getEnvValue<T>(key);
  };

  const saveEnv = async (key: string | undefined, value: any) => {
    if (!key) return;
    const payload = [{ key, value }];
    await envStore.setEnvValue(payload);
  };

  return {
    getEnv,
    saveEnv,
  };
};
